import { req, post, get } from '@/plugins/axios'

/**
* 获取透明购-平台列表
* @param {Object} data
*/
export function getPurePlatformList (data: any) {
  return req('/goods/online/manage/detail/type', data)
}

/**
* 获取平台频道详情
* @param {Object} data
*/
export function getPlatDetail (data: any) {
  return req('/goods/online/manage/detail', data)
}
